import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static get targets () {
        return ['select'];
    }

    connect() {
        for (const tab of this.element.querySelectorAll('[data-tab]')) {
            tab.addEventListener('click', () => this.toggleTab(tab));
        }
    }

    toggleTab(tab) {
        for (const tabContent of this.element.querySelectorAll('.tab-content')) {
            tabContent.classList.remove('tab-content--active');
        }

        for (const tab of this.element.querySelectorAll('[data-tab]')) {
            tab.classList.remove('tab--active');
        }

        const content = this.element.querySelector(`.${tab.getAttribute('data-tab')}`);

        if (content) {
            content.classList.add('tab-content--active');
            tab.classList.add('tab--active');
        }
    }

    selectTargetConnected(element) {
        element.addEventListener('change', () => {
            const value = element.value;

            for (const tabContent of this.element.querySelectorAll('.tab-content')) {
                tabContent.classList.remove('tab-content--active');
            }

            const content = this.element.querySelector(`.${value}`);

            if (content) {
                content.classList.add('tab-content--active');
            }
        });
    }
}